import SuitesCustomer from '../../containers/Customer'
import Layout from '../../components/Layout'

import React from 'react'

export const Customer = ({ history }) => {
  return (
    <Layout isSidebar={true} title='Customers'>
      <SuitesCustomer history={history} />
    </Layout>
  )
}

export default Customer
